<template>
  <div id="firebaseui-auth"></div>
</template>

<script>
import firebase from 'firebase/app'
import * as firebaseui from 'firebaseui'
import firebaseApp from '../firebase-app'
import 'firebaseui/dist/firebaseui.css'

export default {
  name: 'Auth',
  mounted () {
    let ui = firebaseui.auth.AuthUI.getInstance()
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebaseApp.auth())
    }
    ui.start('#firebaseui-auth', {
      signInSuccessUrl: this.$route.query.redirect || '/',
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
      signInOptions: [
        {
          provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          authMethod: 'https://accounts.google.com',
          clientId: '434021624365-ek2mo70d97f2qgoekqp83387p6aed2a3.apps.googleusercontent.com'
        },
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ]
    })
  }
}
</script>

<style lang="scss">
  .firebaseui-container {
    max-width: 768px
  }

  ul.firebaseui-idp-list {
    margin: 0;
    list-style-type: none
  }

  .firebaseui-card-content {
    padding: 0 5px
  }

  .firebaseui-idp-button {
    font-weight: 100;
    max-width: 768px;
    line-height: 36px
  }

  .firebaseui-idp-google {
    .firebaseui-idp-text {
      color: #363636
    }
  }
</style>
